import { appendLocaleSources } from '../../hooks/useTranslate'
import UserPresenter from '../../api/userPresenter'

appendLocaleSources({
  [UserPresenter.urn]: {
    page: {
      title: 'Пользователи',
    },
    modal: {
      title: {
        create: 'Создание пользователя',
        update: 'Обновление пользователя',
      },
    },
    action: {
      create: 'Добавить пользователя',
    },
    message: {
      confirmDelete: `Вы действительно хотите удалить этого пользователя?`,
    },
  },
}, 'ru')

appendLocaleSources({
  [UserPresenter.urn]: {
    page: {
      title: 'Users',
    },
    modal: {
      title: {
        create: 'Create User',
        update: 'Update User',
      },
    },
    action: {
      create: 'Add User',
    },
    message: {
      confirmDelete: `Are you sure you want to delete this user?`,
    },
  },
}, 'en')

appendLocaleSources({
  [UserPresenter.urn]: {
    page: {
      title: 'Foydalanuvchilar',
    },
    modal: {
      title: {
        create: 'Foydalanuvchini yaratish',
        update: 'Foydalanuvchini yangilash',
      },
    },
    action: {
      create: 'Foydalanuvchini qoshish',
    },
    message: {
      confirmDelete: `Ushbu foydalanuvchini o'chirishni xohlaysizmi?`,
    },
  },
}, 'uz')


